/** @module csi/image/ImageFlipVertical **/
define([
	"dojo/_base/lang",
	"csi/def/Action",
	"csi/view/PluginFactory",
	"csi/view/ToolbarPluginButton",
	"csi/image/ImageEditorPluginMixin"
], function(lang,Action,PluginFactory,ToolbarPluginButton,ImageEditorPluginMixin) {

	return PluginFactory.declare("flipvertical", [ToolbarPluginButton, ImageEditorPluginMixin], {
		/**
		 * Set the action for flip vertical
		 */
		constructor: function() {
			this.defAction = lang.mixin(new Action(), {
				m_id: "ImageEditorVertical",
				m_onAction: "flipVertical"
			});
			this.defAction.setMaterialIcon("flip");
			this.defAction.resolve();
		}
	});
});